FroalaEditor.DefineIcon('peeristicsAsset', { NAME: 'image blue'});

FroalaEditor.RegisterCommand('peeristicsAsset', {
    title: 'Add asset',
    undo: false,
    focus: true,
    refreshAfterCallback: false,
    callback: function(cmd, source) {
        // Save current cursor/selection
        this.selection.save();

        var form = this.$el.closest('form');
        var modal = $('#modalAddAssets');
        modal.attr('data-content-block-type', form.data('type'));
        modal.attr('data-content-block-id', form.data('id'));
        if (form.find('.live-editor').data('editor-config') == 'no_attach')
            modal.attr('data-no-attach', true);
        if (form.attr('data-editor') == null || modal.attr('data-editor') == null || form.attr('data-editor') != modal.attr('data-editor')) {
            var id = Utils.generateUUID();
            form.attr('data-editor', id);
            modal.attr('data-editor', id);
        }
        modal.find('.save-and-view').attr('style', 'display: none !important');
        modal.trigger('data-editor-change');
        if (source == 'imagePaste') {
            modal.find('a[href="#modal-add-asset-files"]').tab('show');
            modal.find('.alert-info[data-type="imagePasted"]').removeClass('hidden');
        }
        modal.modal('show');
    }
});
